import {styled} from '@mui/material'

import {useI18n} from 'store/Store'
import StatsItem from './StatsItem'
import {useIsMobile} from 'services/hooks/use-mobile'

const Stats = ({itemsName, stats}) => {
    const {i18n} = useI18n()
    const isMobile = useIsMobile()

    return (
        <Container isMobile={isMobile}>
            {stats.map((item) => (
                <StatsItem
                    key={item.key}
                    Icon={item.icon}
                    label={i18n.t(`${itemsName}.${item.key}`)}
                    value={item.value || 0}
                />
            ))}
        </Container>
    )
}

export default Stats

const Container = styled('div')(({isMobile}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px 12px',
    flexDirection: isMobile ? 'column' : 'row',
}))
